import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { AUTO_ASSESSMENTS_API } from '../autoAssessmentsAPIClient';

export const AUTO_ASSESSMENTS_REQUEST_UNLOCK_KEY =
  'auto-assessments-submit-key';

interface IUseRequestUnlockOptions {
  onErrorCallback: (error: IApiError) => void;
  onSuccessCallback: (msg: string) => void;
}

export interface IUnlockAssessmentRequestPayload {
  sessionId: string;
  identifier?: string;
}

/**
 * To unlock the auto assessments request.
 */
export const useAutoAssessmentsRequestUnlockMutation = ({
  onErrorCallback,
  onSuccessCallback,
}: IUseRequestUnlockOptions) => {
  const {
    isPending,
    error,
    mutate: unlockRequest,
  } = useMutation({
    mutationKey: [AUTO_ASSESSMENTS_REQUEST_UNLOCK_KEY],
    networkMode: 'always',
    mutationFn: ({ sessionId, identifier }: IUnlockAssessmentRequestPayload) =>
      AUTO_ASSESSMENTS_API.unlockAssessmentRequest(sessionId, identifier),
    onError: onErrorCallback,
    onSuccess: onSuccessCallback,
  });

  return {
    error,
    isPending,
    unlockRequest,
  };
};
